class BuyableFilterHero extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.abortController = new AbortController();
    this.planButtons = Array.from(this.querySelectorAll('[data-eg-buy-plan]'));
    this.sellingPlanInput = this.querySelector('[data-eg-selling-plan-input]');
    this.priceNow = this.querySelector('[data-eg-buy-price-now]');
    this.priceWas = this.querySelector('[data-eg-buy-price-was]');
    this.priceSave = this.querySelector('[data-eg-buy-price-save]');

    this.planButtons.forEach((button) => {
      button.addEventListener('click', this.handlePlanClick, { signal: this.abortController.signal });
    });
    this.addEventListener('cart:update', this.handleCartUpdate, { signal: this.abortController.signal });

    const activeButton = this.planButtons.find((button) => button.classList.contains('is-active')) || this.planButtons[0];
    if (activeButton) this.selectPlan(activeButton);
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  handlePlanClick = (event) => {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    this.selectPlan(button);
  };

  handleCartUpdate = (event) => {
    if (event.detail?.data?.didError) return;
    if (event.detail?.data?.source !== 'product-form-component') return;

    requestAnimationFrame(() => this.openCartDrawer());
  };

  selectPlan(button) {
    this.planButtons.forEach((planButton) => {
      const isActive = planButton === button;
      planButton.classList.toggle('is-active', isActive);
      planButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    const sellingPlanId = button.dataset.sellingPlanId || '';
    if (this.sellingPlanInput instanceof HTMLInputElement) {
      if (sellingPlanId) {
        this.sellingPlanInput.name = 'selling_plan';
        this.sellingPlanInput.value = sellingPlanId;
        this.sellingPlanInput.disabled = false;
      } else {
        this.sellingPlanInput.removeAttribute('name');
        this.sellingPlanInput.value = '';
        this.sellingPlanInput.disabled = true;
      }
    }

    this.updatePrice(this.priceNow, button.dataset.priceDisplay);
    this.updatePrice(this.priceWas, button.dataset.compareDisplay, true);
    this.updatePrice(this.priceSave, button.dataset.savingDisplay, true);
  }

  updatePrice(element, value, canHide = false) {
    if (!(element instanceof HTMLElement)) return;

    const nextValue = value || '';
    if (canHide) element.hidden = !nextValue;
    if (nextValue) element.textContent = nextValue;
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!(cartDrawer instanceof HTMLElement)) return;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    if (typeof cartDrawer.showDialog === 'function') {
      cartDrawer.showDialog();
    }
  }
}

if (!customElements.get('buyable-filter-hero')) {
  customElements.define('buyable-filter-hero', BuyableFilterHero);
}
